import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";

import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";

import AsyncSelect from "../common/AsyncSelect";
import Separator from "../common/Separator";

export default class AddMenuItemModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this._getState(props),
      show: props.show,
      isLoading: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps));
  }

  _getState(props) {
    return {
      ...props,
      data: {
        menu: null,
        menu_category: null,
        item: null,
        price: null,
        price_sale: null,
        on_sale: false,
        currency: 1,
        passcode: null
      },
    };
  }

  _isFormValid() {
    const { data } = this.state;

    const { item, price, price_sale, on_sale } = data;

    let error = null;

    if (!item) {
      error = "Please select an item.";
    } else if (price === null) {
      error = "Please enter an item price.";
    } else if (on_sale && price_sale === null) {
      error = "Please enter a sale price.";
    }

    if (error) {
      Notify.error(error);
      return false;
    }

    return true;
  }

  _addMenuItem() {
    let { data } = this.state;

    let { item, price, price_sale, on_sale, currency } = data;

    if (!this._isFormValid()) {
      return;
    }

    this.setState({ isLoading: true });

    data.menu = this.props.menuId;
    data.menu_category = this.props.menuCategoryId;
    data.item = item ? item?.id : null;
    data.passcode = this.props?.passcode

    console.log("printing the data from the addMenuItemModal: ", data);

    Backend.addMenuItem(data)
      .then(() => {
        this.setState({ data, isLoading: false });
        Notify.success("Menu Item has been added successfully.");
        this.props.onUpdated();
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  _getItem(item) {
    return {
      label: item.title,
      value: item.id,
      data: item,
    };
  }

  render() {
    let { show, data, isLoading } = this.state;

    if (!data) {
      return null;
    }

    return (
      <Modal
        show={show}
        onHide={() => {
          if (!isLoading) {
            this.props.onHide();
          }
        }}
      >
        <div className="modal-content">
          <Modal.Header closeButton>
            <Modal.Title> Add Item</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-group row">
              <div data-repeater-list className="col-lg-12">
                <div
                  data-repeater-item
                  className="form-group row align-items-center"
                >
                  <div className="col-xl-12 my-2 my-md-0">
                    <div className="form-group">
                      <label>Items</label>
                      <AsyncSelect
                        endpoint={`${window.Api.Items}`}
                        filter={`category_id=${this.props.categoryId}`}
                        orderBy={"title"}
                        search_term={"title"}
                        getOptions={(items) => {
                          return items.map((item) => this._getItem(item));
                        }}
                        className="form-control h-auto border-0 form-control-solid c-selectbox"
                        name="items"
                        value={data?.item ? this._getItem(data.item) : null}
                        onSelected={(item) => {
                          data.item = item;
                          data.price = item.price;
                          this.setState({ data });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <div className="form-group">
                      <label>Item Price *</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">€</span>
                        </div>
                        <input
                          type="number"
                          className="form-control"
                          placeholder={0.0}
                          name="price"
                          value={data?.price ? data?.price / 100 : null}
                          onChange={(e) => {
                            data.price = e.target.value
                              ? Math.round(
                                  parseFloat(e.target.value).toFixed(2) * 100
                                )
                              : null;

                            this.setState({ data });
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-9 mb-3 mt-15">
                    <label>Is this item on sale?</label>
                  </div>

                  <div className="col-md-3 mb-3 mt-10">
                    <label
                      className="checkbox checkbox-lg"
                      style={{ position: "initial" }}
                    >
                      <input
                        type="checkbox"
                        className="salebox"
                        name="on_sale"
                        checked={data?.on_sale}
                        onClick={(e) => {
                          data.on_sale = e.target.checked;

                          this.setState({ data });
                        }}
                      />
                      <span />
                    </label>
                  </div>
                  {data?.on_sale && (
                    <div className="col-md-12 sale-item mb-3">
                      <label>Sale Price</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">€</span>
                        </div>
                        <input
                          type="number"
                          className="form-control"
                          placeholder={0.0}
                          name="price_sale"
                          value={data?.price_sale ? data?.price_sale / 100 : null}
                          onChange={(e) => {
                            data.price_sale = e.target.value
                              ? Math.round(
                                  parseFloat(e.target.value).toFixed(2) * 100
                                )
                              : null;

                            this.setState({ data });
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-12 sale-item mb-3 mt-5">
                <Separator />
                <span>
                  Please contact Admin if the item is not on the list *
                </span>
                <div className="input-group mt-5">
                  <a
                    href="mailto: customerservice@clinks.ie"
                    target="_blank"
                    className="btn btn-icon btn-sm btn-pill btn-outline-primary mr-2"
                  >
                    <span className="svg-icon svg-icon-md">
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        {" "}
                        <g
                          stroke="none"
                          strokeWidth={1}
                          fill="none"
                          fillRule="evenodd"
                        >
                          {" "}
                          <rect x={0} y={0} width={24} height={24} />{" "}
                          <path
                            d="M5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z"
                            fill="#000000"
                          />{" "}
                        </g>{" "}
                      </svg>
                    </span>{" "}
                  </a>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              className="btn btn-outline-primary font-weight-bold"
              onClick={() => this.props.onHide()}
            >
              Close
            </button>

            <button
              type="button"
              className="btn btn-primary font-weight-bold"
              disabled={isLoading}
              onClick={() => this._addMenuItem()}
            >
              Save Changes
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    );
  }
}
